import { ResumeLanguage } from "lib/redux/types";
import React from "react";
import { TemplateSevenResumeSection, TemplateSevenResumeSectionWithSubsections } from "./common";
import { View } from "@react-pdf/renderer";
import { spacing, styles } from "../ResumePDF/styles";
import { ResumePDFDescription, ResumePDFText } from "../ResumePDF/common";

const Languages = ({
  heading,
  languages,
  themeColor,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  languages: ResumeLanguage[];
  themeColor: string;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateSevenResumeSectionWithSubsections themeColor={themeColor} heading={heading}>
      <View
        wrap={false}
        style={{
          ...styles.flexRow,
          flexWrap: "wrap",
        }}
      >
        {languages.map(({ language, level, descriptions }, idx) => (
          <View
            key={idx}
            style={{
              ...styles.flexCol,
              width: "30%",
              marginBottom: spacing["1"],
              marginRight: spacing["1"],
            }}
          >
            <View style={{ ...styles.flexRow, gap: 4 }}>
              <ResumePDFText bold={true}>• {language}</ResumePDFText>
              {level && <ResumePDFText>({level})</ResumePDFText>}
            </View>
            <View style={{ ...styles.flexRow, marginTop: spacing["0.5"] }}>
              <ResumePDFDescription 
                items={descriptions} 
                enableHighlight={enableHighlight}
                enableMistakeHighlight={enableMistakeHighlight}
                section="languages"
                itemIndex={idx}
              />
            </View>
          </View>
        ))}
      </View>
    </TemplateSevenResumeSectionWithSubsections>
  );
};

export default Languages;
